import { useCallback, useState } from "react";

/*
Custom hook which helps the Layout component know when to display a poster.
*/
export default function usePoster(posterElementOrSrc) {
  const [showPoster, setShowPoster] = useState(Boolean(posterElementOrSrc));
  const hidePoster = useCallback(() => {
    setShowPoster(false);
  }, []);
  return {
    // Only return the poster if it should be shown
    poster: showPoster ? posterElementOrSrc : undefined,
    // Helper that hides the poster
    hidePoster
  };
}